import { Controller } from "stimulus";

export default class extends Controller {

    connect() {
        // this.inputTarget.addEventListener('blur', this.onBlur);
    }
}
